<template>
    <div>
        <div class="form-group row">
            <label class="col-sm-1 text-nowrap" style="min-width: 120px">{{ $t('managerForm.settingPage.pageTypeB.lineDirection') }}</label>
            <div class="col-sm-9">
                <Multiselect
                    :id="`select-direction`"
                    :value.sync="initDesignPrize.direction"
                    :options="OPTION_DESIGN_PRIZE_FORM_B.listSortDirection"
                    :config.sync="layoutPrizeConfig.direction"
                />
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-1 text-nowrap" style="min-width: 120px">{{ $t('managerForm.settingPage.pageTypeB.arrangement') }}</label>
            <div class="col-sm-9">
                <Multiselect
                    :id="`select-arrangement`"
                    :value.sync="initDesignPrize.arrangement"
                    :options="OPTION_DESIGN_PRIZE_FORM_B.listSortArrangement"
                    :config.sync="layoutPrizeConfig.arrangement"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Multiselect from '@/components/Multiselect/main.vue';

import { OPTION_DESIGN_PRIZE_FORM_B, configLayoutPrize } from '@/views/pages/phase2/manager-form/components/setting-page/components/form-b/constants';
import { initLayoutPrizeSerial } from '@/views/pages/phase2/manager-form/constants';
import { onHandleCheckFieldRequired } from '@/utils/handlers';
import { validateField, validateAllField } from '@/utils/validate_v2';

export default {
    name: 'SettingDesignPrizeFormB',
    components: {
        Multiselect
    },
    props: {
        formPrizeDesignInit: {
            type: Object,
            required: true,
            default: () => null
        },

        dataForm: {
            type: Object,
            default: () => null
        }
    },
    data() {
        return {
            OPTION_DESIGN_PRIZE_FORM_B,
            initDesignPrize: initLayoutPrizeSerial(),
            layoutPrizeConfig: configLayoutPrize()
        };
    },
    methods: {
        onHandleCheckFieldRequired,

        getDataFormPrizeDesign() {
            return JSON.parse(JSON.stringify(this.initDesignPrize));
        },
        resetDataFormPrizeDesign() {
            this.initDesignPrize = JSON.parse(JSON.stringify(this.formPrizeDesignInit || initLayoutPrizeSerial()));
        },

        onHandleValid(valueField, configField) {
            validateField(valueField, configField);
        },

        onHandleValidateAll() {
            let isValid = validateAllField(this.initDesignPrize, this.layoutPrizeConfig);
            return isValid;
        }
    },
    watch: {
        formPrizeDesignInit: {
            handler: function (newVal) {
                this.initDesignPrize = JSON.parse(JSON.stringify(newVal || initLayoutPrizeSerial()));
            },
            immediate: true,
            deep: true
        }
    }
};
</script>

<style lang="scss" scoped></style>
